import React, { useState, useEffect } from "react";
import { TypeAnimation } from 'react-type-animation';

export default function Profil() {
    const images = [
        "images/profil1.png",
        "images/profil2.png",
        "images/profil3.png",
    ]; // Array of image paths
    const [currentImageIndex, setCurrentImageIndex] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentImageIndex((prevIndex) =>
                prevIndex === images.length - 1 ? 0 : prevIndex + 1
            );
        }, 3000); // Change image every 3 seconds

        return () => clearInterval(interval); // Clear interval on component unmount
    }, [images.length]);

    return (
        <div id="profil" className="section">
            <div className="container mx-auto max-w-[1200px] px-3 overflow-hidden">
                <div className="font-secondary text-left font-bold mb-12">
                    <div>
                        <TypeAnimation
                            sequence={[
                                '✝✝🟨🕟Kemampuan Skil✝✝💛🌐🌐',
                                3000,
                            ]}
                            wrapper="span"
                            cursor={true}
                            repeat={Infinity}
                            className="mx-3 text-gradient"
                        />
                        <h4 className="text-gradient mb-3 text-primary"></h4>
                        <p className="text-justify font-times" data-aos="fade-up"
     data-aos-duration="3000">
                            Sebagai seorang programmer, saya memiliki tekad yang kuat untuk terus berkembang dan tidak pernah menyerah, bahkan ketika menghadapi tantangan yang kompleks. Saya melihat setiap masalah sebagai peluang untuk meningkatkan keterampilan saya dan selalu berusaha menemukan solusi yang inovatif dan efisien. Dengan kemampuan analitis dan kreativitas yang tinggi, saya mampu mengatasi berbagai hambatan dan menghasilkan kode yang berkualitas. Saya percaya bahwa kesuksesan dalam pemrograman datang dari kombinasi ketekunan, kesabaran, dan semangat untuk terus maju, apapun rintangan yang harus dihadapi.
                        </p>
                    </div>
                </div>
                <div className="flex flex-col lg:flex-row items-center lg:items-start justify-between" data-aos="fade-right"
     data-aos-offset="300"
     data-aos-easing="ease-in-sine">
                    <div className="text-center w-full max-w-[400px] mx-auto mb-12 lg:mb-0">
                    <div className="relative w-[300px] h-[300px] bg-gradient rounded-full overflow-hidden img-size">
    <img
        src={images[currentImageIndex]}
        alt="Darius Amenda"
        className="w-full h-full object-cover animate-fadeIn"
    />
</div>

                        <h2 className="text-gradient text-[30px] mt-4">Darius Amenda</h2>
                    </div>
                    <div className="w-full lg:pt-[50px]">
                        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 text-center">
                            {["/images/1.png", "/images/2.png", "/images/3.png", "/images/4.png"].map((src, index) => (
                                <div key={index} className="w-full">
                                    <div className="relative bg-white h-full flex justify-center items-center rounded-lg overflow-hidden p-5 group transition-all duration-500">
                                        <img src={src} alt={`Image ${index + 1}`} className="w-full h-full object-cover" />
                                        <div className="absolute inset-0 bg-gradient-to-r from-blue-500 to-green-500 opacity-0 scale-0 group-hover:opacity-100 group-hover:scale-100 transition-all duration-300 flex items-center justify-center">
                                            <div className="text-center text-white p-4">
                                                <h4 className="text-xl font-bold mb-2">
                                                    {index === 0 ? "jQuery" : index === 1 ? "Bootstrap" : index === 2 ? "CSS3" : "HTML 5"}
                                                </h4>
                                                <p className="text-sm">Deskripsi terkait pustaka JavaScript atau teknologi yang relevan.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
